// @flow

const parseHTMLEntities = (text: string): string => {
    const element = document.createElement('textarea');
    element.innerHTML = text;
    return element.value;
};

export default parseHTMLEntities;
